import React, { useContext } from 'react';
import './dateRangeSelector.css';
import { DateContext } from '../../context/dateProvider';

const DateRangeSelector = ({ dateRange, setDateRange }) => {
  const { startDate, endDate } = useContext(DateContext);

  const diffDays = endDate.diff(startDate, 'day'); // Diferencia en días

  return (
    <div className={`date_range_selector position-${dateRange}`}>
      {/* Mostrar botón de 1 Día si hay al menos 1 día */}
      {diffDays >= 0 && (
        <button
          className={`date_range_button ${dateRange === 0 ? 'active' : ''}`}
          onClick={() => setDateRange(0)}
        >
          1 Día
        </button>
      )}

      {/* Mostrar botón de 1 Semana si diferencia >= 6 */}
      {diffDays >= 6 && (
        <button
          className={`date_range_button ${dateRange === 1 ? 'active' : ''}`}
          onClick={() => setDateRange(1)}
        >
          1 Sem
        </button>
      )}

      {/* Mostrar botón de 1 Mes si diferencia >= 29 */}
      {diffDays >= 29 && (
        <button
          className={`date_range_button ${dateRange === 2 ? 'active' : ''}`}
          onClick={() => setDateRange(2)}
        >
          1 Mes
        </button>
      )}
    </div>
  );
};

export default DateRangeSelector;
